import store from '@/xreports/store/index'

export default {
  deviceMode: state => {
    const windowInnerWidth = state.common.windowInnerWidth
    return windowInnerWidth < 1024 ? 'mobile' : windowInnerWidth < 1366 ? 'pad' : 'pc'
  },
  hotelInfo: state => {
    return state.common.hotelInfo
  },
  dateFilter: state => state.common.dateFilter,
  token: () => store.state.systemUser.token,
  userInfo: () => store.state.systemUser.userInfo,
  watermarkText: () => {
    const userInfo = store.state.systemUser.userInfo
    if (!userInfo || !userInfo.userName) {
      return ''
    }
    if (!userInfo.account) {
      return userInfo.userName || ''
    }
    let suffix = ''
    if (userInfo.account.length > 4) {
      suffix = userInfo.account.substring(userInfo.account.length - 4)
    }
    return userInfo.userName + suffix
  },
  showPermissionsDialog: state => {
    return state.common.showPermissionsDialog
  },
  actionAuthorityMap: state => {
    const { menuRoutes } = state.menus
    const getChildren = obj => {
      let res = []
      obj?.map(item => {
        res.push(item)
        if (item.children?.length) {
          res = res.concat(getChildren(item.children))
        }
      })
      return res
    }
    const list = getChildren(menuRoutes)

    return list.reduce((res, item) => {
      res[item.code] = true
      return res
    }, {})
  },
  currentDepId: state => state.common.currentDepId,
  currentDepInfo: state => state.common.currentDepInfo,
}
